// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1FZg7","right":"styles_right__2x-QE"};